function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { useMemo, useRef } from "react";
import PropTypes from "prop-types";
import { getStickyItemInfo } from "../utils/sticky";
import { DEFAULT_BREAKPOINT } from "../utils/css";
import useTheme from "../hooks/useTheme";
import useSticky, { StickyProvider } from "../hooks/useSticky";
import { responsiveHeightType } from "../hooks/useResponsiveProp";
import { jsx as ___EmotionJSX } from "@emotion/core";

function Item(_ref) {
  var children = _ref.children,
      testId = _ref.testId;
  var theme = useTheme();

  var _useSticky = useSticky(getStickyItemInfo(children, theme)),
      css = _useSticky.css;

  return ___EmotionJSX("div", {
    css: css,
    "data-testid": testId
  }, children);
}

Item.propTypes = _objectSpread(_objectSpread({}, responsiveHeightType), {}, {
  children: PropTypes.node,
  testId: PropTypes.string
});

function Sticky(props) {
  var children = props.children,
      testId = props.testId;
  var theme = useTheme();
  var initialOffsetMap = useMemo(function () {
    var result = _defineProperty({}, DEFAULT_BREAKPOINT, 0);

    for (var bp in theme.breakpoints) {
      result[bp] = 0;
    }

    return result;
  }, [theme]);
  var accumulativeOffsetMap = useRef(initialOffsetMap);
  var offsetMap = useRef({});

  var updateOffsetMap = function updateOffsetMap(id, heightMap) {
    if (!offsetMap.current[id]) {
      offsetMap.current[id] = _objectSpread({}, accumulativeOffsetMap.current); // Spread is important here since `accumulativeOffsetMap.current` is updated below.

      for (var bp in heightMap) {
        accumulativeOffsetMap.current[bp] += heightMap[bp];
      }
    }
  };
  /*
    Without this div, we have no control over sticky items' parent.
    If the parent ends up having `height: 100vh`, for example, the sticky items won't stick. 
  */


  return ___EmotionJSX(StickyProvider, {
    value: {
      accumulativeOffsetMap: accumulativeOffsetMap.current,
      offsetMap: offsetMap.current,
      updateOffsetMap: updateOffsetMap
    }
  }, ___EmotionJSX("div", {
    "data-testid": testId
  }, children));
}

Sticky.propTypes = {
  children: PropTypes.node.isRequired,
  testId: PropTypes.string
};
Sticky.Item = Item;
export default Sticky;